import React from 'react';
import { func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockDefault.module.css';
import ListingCardSection from '../../../../components/ListingCardSection/ListingCardSection';
import Collapsible from 'react-collapsible';
import SectionMap from '../../SectionBuilder/SectionMap/SectionMap';
import { REGION_MAP_BLOCK, REGION_MAP_SECTION } from '../../../../constants';

const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

const BlockDefault = props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    alignment,
    sectionId
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  const alignmentClasses = {
    left: css.alignLeft,
    center: css.alignCenter,
    right: css.alignRight,
  };

  const alignmentClass = alignmentClasses[alignment];

  const isRegionMapBlock = sectionId === REGION_MAP_SECTION && blockId === REGION_MAP_BLOCK;

  return (
    <BlockContainer id={blockId} className={classes}>
      {!isRegionMapBlock ? (
        <FieldMedia
          media={media}
          sizes={responsiveImageSizes}
          className={mediaClassName}
          options={options}
        />
      ) : null}
      {sectionId === 'travel_tips_details' ? (
        <div className={css.faqContent}>
          <div className={css.faqText}>
            <Collapsible trigger={<Field data={title} options={options} />}>
              <div className={css.collapsibleContent}>
                <Field data={text} options={options} />
              </div>
            </Collapsible>
          </div>
        </div>
      ) : blockId === 'experts_slider' ? (
        <div>
          <ListingCardSection country={title?.content ?? ''} />
        </div>
      ) : isRegionMapBlock ? (
        <SectionMap
          key={`${sectionId}_${blockId}`}
          id={`${sectionId}_${blockId}`}
          // className={classes}
          title={title}
          rootClassName={css.mapWrapper}
          // defaultClasses={DEFAULT_CLASSES}
          sectionId={sectionId}
        />
      ) : hasTextComponentFields ? (
        <div className={classNames(textClassName, alignmentClass, css.text)}>
          <Field data={title} options={options} />
          <Field data={text} options={options} />
          <Field data={callToAction} className={ctaButtonClass} options={options} />
        </div>
      ) : null}
    </BlockContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

BlockDefault.defaultProps = {
  className: null,
  rootClassName: null,
  mediaClassName: null,
  textClassName: null,
  ctaButtonClass: null,
  title: null,
  text: null,
  callToAction: null,
  media: null,
  responsiveImageSizes: null,
  options: null,
};

BlockDefault.propTypes = {
  blockId: string,
  className: string,
  rootClassName: string,
  mediaClassName: string,
  textClassName: string,
  ctaButtonClass: string,
  title: object,
  text: object,
  callToAction: object,
  media: object,
  responsiveImageSizes: string,
  options: propTypeOption,
};

export default BlockDefault;
